import { Navigate } from 'react-router';
import { useAppSelector } from '../Infrastructure/store';
import useUserTerminals from '../Hooks/useUserTerminals';
import ApplicationError from '../Infrastructure/Components/ErrorHandling/ApplicationError';
import { ApplicationErrorType } from '../Infrastructure/Components/ErrorHandling/types';

/**
 * Initial route for the Application that will display the Users available sites and allow them to select one.
 */
export default function Sites() {
	const { defaultTerminal, terminals, isLoading } = useUserTerminals();
	const selectedTerminal = useAppSelector((state) => state.applicationState.selectedTerminal);

	// If a site is selected, go there
	if (selectedTerminal && terminals.includes(selectedTerminal)) {
		return <Navigate to={selectedTerminal.number} />;
	}

	// Otherwise, try to get the default site and go there
	if (isLoading) {
		return <>Loading Terminals</>;
	}

	if (defaultTerminal) {
		return <Navigate to={defaultTerminal.number} />;
	}

	// There was no default, see if there is anything?
	if (terminals.length > 0) {
		return <Navigate to={terminals[0].number} />;
	}

	// At this point you did not have any terminals
	return <ApplicationError type={ApplicationErrorType.NoTerminals} />;
}
